import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import {
  ArrayField,
  ArrayInput,
  AutocompleteInput,
  AutocompleteArrayInput,
  BooleanField,
  BooleanInput,
  ChipField,
  Datagrid,
  DateInput,
  FileField,
  FileInput,
  FormDataConsumer,
  FunctionField,
  ImageField,
  NumberField,
  NumberInput,
  Pagination,
  RadioButtonGroupInput,
  ReferenceArrayField,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  ReferenceManyField,
  required,
  SelectArrayInput,
  SelectField,
  SelectInput,
  SimpleFormIterator,
  SingleFieldList,
  TextField,
  TextInput,
  UrlField,
  useRecordContext,
  useResourceContext,
  useTranslate,
  number,
  useCreate,
  useNotify,
  Labeled,useDataProvider
} from "react-admin";

import { useFormContext, useWatch } from "react-hook-form";
import styled from "styled-components";
import { Slide } from "@mui/material";
import alasql from "alasql";
import { generateSQLRoleFields, roles } from "./config";
import GoogleMapsInput from "./googleMaps/GoogleMapsInput";
import OperationPlanInput from "./components/custom/Aman/OperationPlanInput";
import OperationPlanField from "./components/custom/Aman/OperationPlanField";
import OperationPlanMultiInput from "./components/custom/Aman/OperationPlanMultiInput";
import OperationPlanMultiField from "./components/custom/Aman/OperationPlanMultiField";
import BlacklistedDriverInput from "./components/custom/Aman/BlacklistedDriverInput";
import BlacklistedDriverField from "./components/custom/Aman/BlacklistedDriverField";
import { Description, PhotoCamera } from "@mui/icons-material";
import { Chip } from "@mui/material";
import classnames from "classnames";
import "handsontable/dist/handsontable.full.css";
import { ColorInput } from "./core/ColorInput/ColorInput";
import GridShow from "./core/components/fields/GridShow";
import GridInput from "./core/components/inputs/GridInput";
import DefaultListGrid from "./core/resource/ui/DefaultListGrid";
import TabedListGrid from "./core/resource/ui/TabedListGrid";
import { Button } from "@mui/material";
import {
  BulkUpdateFormButton,
  InputSelectorForm,
} from "@react-admin/ra-form-layout";
import {AdvancedSelectInput,AdvancedFilterInput,SelectDisplayField} from "./components/custom/AdvancedSelectInput"; // Ensure this path is correct
import {
  CarPlateField,
  CarPlateInput,
  CarPlateFilter,
  CarPlateInputWatch
} from "./components/custom/Aman/CarePlate";


import 
  DateRangeInput
 from "./components/custom/DateRangeInput";



import {
  CustomNidSearch,
  CustomNidSearchBlacklist,
  CustomNidActions,
  CustomVehicleActions,
} from "./components/custom/Aman/CustomActions/nidSearch";
import 
  CustomArrayInput
 from "./components/custom/Aman/CustomArrayInput";



import {
  CustomPlateSearch,
  CustomPlateActions,
  CustomVehiclePlateActions,
} from "./components/custom/Aman/CustomActions/plateSearch";

import {
  TextInputWatchDriver,
  IsOdsChangeWatchDriver,
  useWatchVehicleInput,
  useWatchDriverInput,
} from "./components/custom/Aman/OdsSearch/driver";

import {

  TextInputWatch,
  TextInputWatchThreshold,
  BooleanInputWatch,
  BooleanInputWatchDriver,
  TrainingInputWatch,
  IsOdsWatchMainOds,
  ReferenceFieldInputNewWatch,
  ReferenceFieldInputSearchNewWatch,
  ReferenceFieldInputSingleSearchNewWatch,
  DateInputWatch,
  DateInputWatchDriver,
  HijriDateInputWatch,
  DateTimeInputWithWatch,
  NumberInputWatch,
  MarkDownWatch,
  DriverNIDInput,
  DriverNIDInputBlacklist



} from "./components/custom/Aman/OdsSearch/vehicle";

import EditableJsonTable from "./components/custom/Aman/EditableJsonTable";
import EditableRecordFields from "./components/custom/Aman/EditableRecordFields";
import {
  QuestionSettingArrayInput,
  QuestionSettingArrayField,
} from "./components/custom/Aman/QuestionSettingArray";

import {

  AttachmentInput,
  AttachmentPreview,
  AdvancedAttachmentInput

} from "./components/custom/Attachements";
import {

  DriverFaultRateInput

} from "./components/custom/DriverFaultRateInput";

import {

  TimelineInput,TimelineShow

} from "./components/custom/TimelineInput";

import {

  SchoolAutocomplete,SchoolAutocompleteFilter

} from "./components/custom/SchoolAutocomplete";

import {

  ComputedAgeInputWatch,HiddenColumn

} from "./components/custom/ComputedAgeInputWatch";

import SaudiIdInput from "./components/custom/SaudiIdInput";
import SaudiMobileInput from "./components/custom/SaudiMobileInput";

import 

  KMLPreview

 from "./components/custom/KMLPreview";

//const { control } = useFormContext();
//const { control } = useFormContext();


import 
  
  ShowReportsMenuField

 from "./components/custom/ShowReportsMenuField";


import { useInput } from "react-admin";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormHelperText, FormControl, InputLabel } from "@mui/material";
import { DateTime } from "luxon";


export const factoryMapHook = (
  f,
  index,
  input_widget,
  component,
  className,
  record,
  id
) => {
  //console.log(record);
  const { field_meta, source_name, css_class, full_width, is_required,disabled,watched_column } = f;

  
 



  let choices = {};
  let meta, reference, referancesRourceName, referancesSource;

  switch (input_widget) {
    case "excel_input":
      component = excelInput(component, source_name, index, css_class);
      break;

    case "grid_input":
      component = GridInputExtended(
        component,
        source_name,
        index,
        css_class,
        field_meta
      );
      break;
    case "status_field":
      component = StatusField(
        component,
        source_name,
        index,
        css_class,
        field_meta
      );
      break;

    case "grid_show":
      component = GridShowExtended(
        component,
        source_name,
        index,
        css_class,
        field_meta
      );
      break;
    case "map_input":
      component = mapInput(component, index, source_name, css_class,is_required);
      break;

    case "custom_acls_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        customAclsInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;

    case "custom_acls_show":
      component = customAclsShow(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        source_name,
        index,
        css_class
      );
      break;




 

    case "report_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        reportInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;
    case "report_show":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        reportShow(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;

    case "referance_field_input_new":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldInputNew(
          source_name,
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          is_required,
          disabled
        ));
      break;

      case "referance_field_input_new_watch_main":
          return (
            <ReferenceFieldInputNewWatch
              source_name={source_name}
              meta={meta}
              field_meta={field_meta}
              reference={reference}
              referancesRourceName={referancesRourceName}
              referancesSource={referancesSource}
              index={index}
              css_class={css_class}
              is_required={is_required}
              watched_column={watched_column}
            />
          );
        
        break;

        case "referance_field_input_new_watch_main_filter":
          component = referanceFieldInputFilter(
            component,
            source_name,
            index,
            css_class,
            full_width,
            disabled,
            field_meta
          );

          
          break;
          
          case "referance_field_input_search_watch_main_filter":
            component = referanceFieldInputSearchFilter(
              component,
              source_name,
              index,
              css_class,
              full_width,
              disabled,
              field_meta
            );
  
            
            break;

              

        

        case "referance_field_input_search_watch_main":
            return (
              <ReferenceFieldInputSearchNewWatch
                source_name={source_name}
                meta={meta}
                field_meta={field_meta}
                reference={reference}
                referancesRourceName={referancesRourceName}
                referancesSource={referancesSource}
                index={index}
                css_class={css_class}
                is_required={is_required}
                watched_column={watched_column}

              />);

         
          break;

          case "referance_field_input_single_search_watch_main":
            return (
              <ReferenceFieldInputSingleSearchNewWatch
                source_name={source_name}
                meta={meta}
                field_meta={field_meta}
                reference={reference}
                referancesRourceName={referancesRourceName}
                referancesSource={referancesSource}
                index={index}
                css_class={css_class}
                is_required={is_required}
                watched_column={watched_column}

              />);

         
          break;

    case "reference_text_new":
      // ex: users.user_id.name
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceTextNew(
          source_name,
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;
    case "reference_text_new_disabled":
      // ex: users.user_id.name
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceTextNewDisabled(
          source_name,
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;

          case "reference_text_new_seprated_disabled":
      // ex: users.user_id.name
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceTextNewDisabledSeperated(
          source_name,
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;


    case "service_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        serviceInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;
    case "service_show":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        serviceShow(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;

    case "approval_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        approvalInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;
    case "approval_show":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        approvalShow(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;




    case "referance_depenancy_input_search_multi_filter":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearchMultiFilter(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;

    case "question_array_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        questionArrayInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;
    case "answer_set_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        answerSetInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class
        ));
      break;
    case "school_plan_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        schoolPlanInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class,
          is_required
        ));
      break;
    case "color_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        colorInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class,
          is_required
        ));
      break;

    case "bus_school_plan_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        busSchoolPlanInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          source_name,
          index,
          css_class,
          is_required
        ));
      break;

    case "question_setting_field":
      component = questionSettingField(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "question_setting_input":
      component = (
        <QuestionSettingArrayInput
          source={source_name}
          label={field_meta || "قائمة الأسئلة"}
          className={css_class}
        />
      );
      break;
    case "question_setting_show":
      component = (
        <QuestionSettingArrayField
          source={source_name}
          label={field_meta || "قائمة الأسئلة"}
          className={css_class}
        />
      );
      break;
    case "answer_setting_field":
      component = answerSettingField(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "school_plan_field":
      component = schoolPlanField(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "bus_school_plan_field":
      component = busSchoolPlanField(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "show_meeting":
      component = showMeeting(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "show_meeting2":
      component = showMeeting2(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "show_location":
      component = showLocation(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "show_course":
      component = showCourse(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;

    case "question_images":
      component = questionImage(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;
    case "target_schools":
      component = target_schools(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;

    case "target_inspectors":
      component = target_inspectors(
        meta,
        field_meta,
        source_name,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;

    case "reference_plate":
      // ex: users.user_id.name
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referencePlate(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;

    case "icons_questions":
      // ex: users.user_id.name
      component = iconQuestions(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class
      );
      break;

    case "reference_photo_count":
      // ex: users.user_id.name
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referencePhotoCount(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;
    case "reference_notes_count":
      // ex: users.user_id.name
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceNoteCount(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;
    case "reference_exclude":
      // ex: users.user_id.name
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceIsExclude(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class
        ));
      break;

    case "long_text_input_role1":
      component = longTextInputRole1(
        component,
        source_name,
        index,
        css_class,
        is_required,
        full_width
      );
      break;

    case "long_text_input_role2":
      component = longTextInputRole2(
        component,
        source_name,
        index,
        css_class,
        is_required,
        full_width
      );
      break;

    case "date_input_fix":
      component = dateInput(
        component,
        source_name,
        index,
        css_class,
        full_width,
        is_required
      );
      break;

    case "date_input_fix2":
      component = dateInput2(
        component,
        source_name,
        index,
        css_class,
        full_width,
        is_required
      );
      break;

    case "fail_referance_field_input":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFailFieldInput(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          is_required
        ));
      break;

    case "acl_businesses_input":
      component = aclBusinessesInput(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class,
        is_required
      );
      break;

    case "acl_schools_input":
      component = aclSchoolsInput(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class,
        is_required
      );
      break;

    case "acl_contractors_input":
      component = aclContractorsInput(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class,
        is_required
      );
      break;

    case "acl_regions_input":
      component = aclRegionsInput(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        index,
        css_class,
        is_required
      );
      break;

    case "excel_input2":
      component = excelInput(component, source_name, index, css_class);
      break;
    case "excel_field":
      component = excelField(
        field_meta,
        component,
        source_name,
        index,
        css_class
      );
      break;

    case "reference_many_to_many_field":
      component = reference_many_to_many_field(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        source_name,
        index,
        css_class,
        is_required
      );
      break;
    case "reference_many_to_many_input":
      component = reference_many_to_many_input(
        meta,
        field_meta,
        reference,
        referancesRourceName,
        referancesSource,
        component,
        source_name,
        index,
        css_class,
        is_required
      );
      break;

    case "reference_resource_bulk_action":
      // ex: users.user_id.name
      component = referenceResourceBulkAction(
        field_meta,
        component,
        index,
        record,
        f,
        id
      );
      break;

    case "autocomplete_multi_input":
      var extraProps = JSON.parse(field_meta);

      component = (
        <ReferenceArrayInput
          source={source_name}
          reference={extraProps.reference_resource}
          perPage={extraProps.limit}
        >
          <SelectArrayInput>
            <ChipField source={extraProps.reference_source} />
          </SelectArrayInput>
        </ReferenceArrayInput>
      );
      break;

    case "autocomplete_multi_input_depandancy":
      var extraProps = JSON.parse(field_meta);

      component = (
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <>
              <ReferenceArrayInput
                source={source_name}
                reference={extraProps.reference_resource}
                perPage={extraProps.limit}
                filter={{
                  [extraProps.filter_key]: formData[extraProps.filter_column],
                }}
                // filterToQuery={(searchText: any) => ({ [extraProps.filter_key]: searchText })}

                //  enableGetChoices={({ q }) => (q ? q.length >= 2 : false)}
                {...rest}
              >
                <SelectArrayInput>
                  <ChipField source={extraProps.reference_source} />
                </SelectArrayInput>
              </ReferenceArrayInput>
            </>
          )}
        </FormDataConsumer>
      );
      break;

    case "reference_select_depandancy":
      var extraProps = JSON.parse(field_meta);

      component = (
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <>
              {formData[extraProps.filter_column] && (
                <ReferenceInput
                  source={source_name}
                  reference={extraProps.reference_resource}
                  perPage={extraProps.limit}
                  filter={{
                    [extraProps.filter_key]: formData[extraProps.filter_column],
                  }}
                  {...rest}
                >
                  <SelectInput optionText={extraProps.reference_source} />
                </ReferenceInput>
              )}
            </>
          )}
        </FormDataConsumer>
      );
      break;

    case "custom_rafed_contract_vehicles":
      var extraProps = JSON.parse(field_meta);

      component = (
        <ArrayInput label="الحافلات المتعاقد عليها " source={source_name}>
          <SimpleFormIterator disableRemove>
            <FormDataConsumer>
              {(formDataProps) => {
                if (!formDataProps.getSource) {
                  return null;
                }
                const { getSource, scopedFormData, ...rest } = formDataProps;
                return (
                  <StyledContainer>
                    <StyledInnerContainer key="vehicles">
                      <TextInput
                        label="عدد الحافلات"
                        source={getSource("vehicles")}
                      />
                    </StyledInnerContainer>
                    <StyledInnerContainer key="vehicle_type">
                      <ReferenceInput
                        label="نوع الحافلة"
                        source={getSource("vehicle_type")}
                        reference="domains_vehicle_types"
                        perPage={200}
                      >
                        <SelectInput optionText="name" />
                      </ReferenceInput>
                    </StyledInnerContainer>
                    <StyledInnerContainer key="vehicle_seat">
                      <ReferenceInput
                        label="مقاعد الحافلة"
                        reference="domains_vehicle_seats"
                        source={getSource("vehicle_seat")}
                        perPage={200}
                      >
                        <SelectInput optionText="name" />
                      </ReferenceInput>
                    </StyledInnerContainer>
                    <StyledInnerContainer key="schools">
                      <ReferenceInput
                        label="المدرسة"
                        reference="schools"
                        source={getSource("schools")}
                        perPage={200}
                      // filter={{ 'business_id': formData['business_id'] }}
                      >
                        <SelectInput optionText="name" />
                      </ReferenceInput>
                    </StyledInnerContainer>
                  </StyledContainer>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      );
      break;

    case "custom_rafed_contract_penalites":
      var extraProps = JSON.parse(field_meta);

      component = (
        <ArrayInput label="تعريف مخالفات العقد" source={source_name}>
          <SimpleFormIterator disableRemove>
            <FormDataConsumer>
              {(formDataProps) => {
                if (!formDataProps.getSource) {
                  return null;
                }

                const { getSource, scopedFormData, ...rest } = formDataProps;
                return (
                  <StyledContainer>
                    <StyledInnerContainer key="lineId">
                      <TextInput
                        label="رقم البند"
                        source={getSource("lineId")}
                      />
                    </StyledInnerContainer>
                    <StyledInnerContainer key="penality_calculation_id">
                      <ReferenceInput
                        label="تعريف  المخالفة"
                        source={getSource("penality_calculation_id")}
                        reference="domains_penalties_calculations"
                        perPage={200}
                      >
                        <SelectInput optionText="name" />
                      </ReferenceInput>
                    </StyledInnerContainer>
                  </StyledContainer>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      );
      break;

    // case "multiline":
    //   widget = <TextInput {...props} multiline {...input_widget_attributes} />;
    //   break;
    case "number":
      var extraProps = JSON.parse(field_meta);

      component = (
        <NumberInput
          
          source={source_name}
          validate={is_required ? [required(),number()] : [number()]}
          defaultValue={extraProps.defaultValue ?? ""} // Set default to 0 if not provided


          // label={props.label}
          // helperText={props.helper_text}
          fullWidth
          {...extraProps}
        />
      );
      break;



      case "number_input_watch_main":

        component = (
          <NumberInputWatch
            source_name={source_name}
            index={index}
            is_required={is_required}
            validate={is_required ? [required(),number()] : [number()]}
            fullWidth
            watched_column={watched_column}
            field_meta={field_meta}
          

          />
        );
        break;



        


    case "date":
      var extraProps = JSON.parse(field_meta);

      component = (
        <DateInput
          source={source_name}
          // label={props.label}
          //helperText={props.helper_text}
          fullWidth
          {...extraProps}
        />
      );
      break;

    case "autocomplete_multi_field":
      var extraProps = JSON.parse(field_meta);

      component = (
        <ReferenceArrayField
          source={source_name}
          reference={extraProps.reference_resource}
          perPage={extraProps.limit}
        >
          <SingleFieldList>
            <ChipField source={extraProps.reference_source} />
          </SingleFieldList>
        </ReferenceArrayField>
      );
      break;

    case "referance_depenancy_input_search_new":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearchNew(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;

    case "referance_depenancy_input_search_new2":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearchNew3(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;

    case "referance_depenancy_input_select_new":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearchNew2(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;


          case "referance_depenancy_input_select_new_filter":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearchNew2Filter(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;


    case "referance_depenancy_input_select":
      ({ meta, reference, referancesRourceName, referancesSource, component } =
        referenceFieldDepenancyInputSearchSelect(
          meta,
          field_meta,
          reference,
          referancesRourceName,
          referancesSource,
          component,
          index,
          css_class,
          full_width,
          is_required,
          source_name
        ));
      break;

    case "text_input_watch_driver":
      component = (
        <TextInputWatchDriver
          source_name={source_name}
          index={index}
          is_required={is_required}
        />
      );
      break;

      case "computed_age_input":
        component = (
          <ComputedAgeInputWatch
            source_name={source_name}
            index={index}
            is_required={is_required}
            field_meta={field_meta}

          />
        );
        break;

        case "hidden_input":
          component = (
            <HiddenColumn
              source_name={source_name}
              index={index}
              is_required={is_required}
              field_meta={field_meta}
  
            />
          );
          break;

        case "saudi_id_input":
          component = (
            <SaudiIdInput
              source_name={source_name}
              index={index}
              is_required={is_required}
              field_meta={field_meta}
            />
          );
          break;

        case "saudi_mobile_input":
          component = (
            <SaudiMobileInput
              source_name={source_name}
              index={index}
              is_required={is_required}
              field_meta={field_meta}
            />
          );
          break;

        
        


      case "text_input_watch_main":
        component = (
          <TextInputWatch
            source_name={source_name}
            index={index}
            is_required={is_required}
            watched_column={watched_column}

          />
        );
        break;

      case "text_input_watch_threshold":
        component = (
          <TextInputWatchThreshold
            source_name={source_name}
            index={index}
            is_required={is_required}
            watched_column={watched_column}
            field_meta={field_meta}
          />
        );
        break;


        case "markdown_watch_main":
          component = (
            <MarkDownWatch
              source_name={source_name}
              index={index}
              is_required={is_required}
              watched_column={watched_column}
  
            />
          );
          break;


                case "date_input_watch_main_driver":
          component = (
            <DateInputWatchDriver
              source_name={source_name}
              index={index}
              is_required={is_required}
              watched_column={watched_column}
              field_meta={field_meta}

  
            />
          );
          break;


        case "date_input_watch_main":
          component = (
            <DateInputWatch
              source_name={source_name}
              index={index}
              is_required={is_required}
              watched_column={watched_column}
              field_meta={field_meta}

  
            />
          );
          break;

          case "hdate_input_watch_main":
            component = (
              <HijriDateInputWatch
                source_name={source_name}
                index={index}
                is_required={is_required}
                watched_column={watched_column}
                field_meta={field_meta}

    
              />
            );
            break;

            case "accident_time_input_watch":
              component = (
                <DateTimeInputWithWatch
                  source_name={source_name}
                  index={index}
                  is_required={is_required}
                  watched_column={watched_column}
                  field_meta={field_meta}
  
      
                />
              );
              break;

                            case "custom_plate_input_watch":
                component = (
                   <CarPlateInputWatch
                          source={source_name}
                          label="رقم اللوحة"
                          fullWidth
                          arabic
                      is_required={is_required}
                  watched_column={watched_column}
                  field_meta={field_meta}
                          type={"transport"}
                          sx={{ flex: '0 0 30%' }} // Set the CarPlateInput to take 50% of the width
                        />

                );
                break;


            
              case "custom_plate_input":
                component = (
                   <CarPlateInput
                          source={source_name}
                          label="رقم اللوحة"
                          fullWidth
                          arabic
                          type={"transport"}
                          onChange={(newValue) => console.log("Updated Value:", newValue)}
                          sx={{ flex: '0 0 30%' }} // Set the CarPlateInput to take 50% of the width
                        />

                );
                break;

                case "custom_plate_field":
                  component = (
                    <CarPlateField
                           source={source_name}
                           label="رقم اللوحة"
                            arabic
                           type={"transport"}
                           sx={{ flex: '0 0 30%' }} // Set the CarPlateInput to take 50% of the width
                         />
 
                 );
                  break;


        case "is_ods_watch_main":
          component = (
            <IsOdsWatchMainOds
              field_meta={field_meta}
              source_name={source_name}
              index={index}
              css_class={css_class}
              is_required={is_required}
              watched_column={watched_column}

            />
          );
          break;

        case "text_boolean_watch_main":
          component = (
            <BooleanInputWatch
              field_meta={field_meta}
              source_name={source_name}
              index={index}
              css_class={css_class}
              is_required={is_required}
              watched_column={watched_column}

            />
          );
          break;

          case "text_boolean_watch_main_driver":
          component = (
            <BooleanInputWatchDriver
              field_meta={field_meta}
              source_name={source_name}
              index={index}
              css_class={css_class}
              is_required={is_required}
              watched_column={watched_column}

            />
          );
          break;


        case "traning_watch_main":
          component = (
            <TrainingInputWatch
              field_meta={field_meta}
              source_name={source_name}
              index={index}
              css_class={css_class}
              is_required={is_required}
              watched_column={watched_column}

            />
          );
          break;

          

          case "attachment_input":
            component = (
              <AttachmentInput
                field_meta={field_meta}
                source_name={source_name}
                index={index}
                css_class={css_class}
                is_required={is_required}
              />
            );
            break;


          case "advanced_attachment_input":
            component = (
              <AdvancedAttachmentInput
                field_meta={field_meta}
                source_name={source_name}
                index={index}
                css_class={css_class}
                is_required={is_required}
              />
            );
            break;

            case "advanced_select_input":
              component = (
                <AdvancedSelectInput
                  field_meta={field_meta}
                  source_name={source_name}
                  index={index}
                  css_class={css_class}
                  is_required={is_required}
                />
              );
              break;
              case "advanced_select_input_filter":
                component = (
                  <AdvancedFilterInput
                    field_meta={field_meta}
                    source_name={source_name}
                    index={index}
                    css_class={css_class}
                    is_required={is_required}
                  />
                );
                break;

                case "advanced_select_show":
                  component = (
                    <SelectDisplayField
                      field_meta={field_meta}
                      source_name={source_name}
                      index={index}
                      css_class={css_class}
                      is_required={is_required}
                    />
                  );
                  break;

            case "timeline_approval":
              component = (
                <TimelineInput
                  field_meta={field_meta}
                  source_name={source_name}
                  index={index}
                  css_class={css_class}
                  is_required={is_required}
                />
              );
              break;
              case "timeline_approval_show":
                component = (
                  <TimelineShow
                    field_meta={field_meta}
                    source_name={source_name}
                    index={index}
                    css_class={css_class}
                    is_required={is_required}
                  />
                );
                break;
  

              case "driver_fault_rate_input":
                component = (
                  <DriverFaultRateInput
                    field_meta={field_meta}
                    source_name={source_name}
                    index={index}
                    css_class={css_class}
                    is_required={is_required}
                    watched_column={watched_column}

                  />
                );
                break;


                         case "input_full_text_search_depend":
              component = (
                <SchoolAutocomplete
                  field_meta={field_meta}
                  source_name={source_name}
                  index={index}
                  css_class={css_class}
                  is_required={is_required}
                  watched_column={watched_column}
                                  />
              );
              break;

              case "input_full_text_search_depend_filter":
                component = (
                   <SchoolAutocompleteFilter
                          source={source_name}
                          fullWidth
                          field_meta={field_meta}
                          index={index}
                          is_required={is_required}


                      
                        />
  
                );
                break;
       
              
            
          case "attachment_preview":
            component = (
              <AttachmentPreview
                field_meta={field_meta}
                source_name={source_name}
                index={index}
              />
            );
            break;
          


    case "boolean_input_watch_driver":
      component = (
        <IsOdsChangeWatchDriver
          source_name={source_name}
          index={index}
          is_required={is_required}
        />
      );
      break;

    case "vehicle_meta_data":
      component = (
        <VehicleMetaDataForm
          source_name={source_name}
          index={index}
          is_required={is_required}
        />
      );
      break;

    case "custom_nid_search":
      component = (
        <CustomNidSearch source={source_name} label={""} key={index} />
      );
      break;

        case "custom_nid_search_blacklist":
      component = (
        <CustomNidSearchBlacklist source={source_name} label={""} key={index} />
      );
      break;

      

      case "custom_plate_search":
        component = (
          <CustomPlateSearch source={source_name} label={""} key={index} />
        );
        break;

    case "custom_nid_actions":
      component = (
        <CustomNidActions source={source_name} label={""} key={index} />
      );
      break;

    case "custom_vehicle_actions":
      component = (
        <CustomVehicleActions source={source_name} label={""} key={index} />
      );
      break;

      case "custom_escalation_config":
        component = (
           <CustomArrayInput
                  source={source_name}
        
                />

        );
        break;

    case "custom_editable_json_table":
      var extraProps = JSON.parse(field_meta);

      component = (
        <EditableJsonTable
          title={extraProps.title}
          columns={extraProps.columns}
          initialData={extraProps.initialData}
          source={source_name}
        />
      );
      break;
      case "custom_editable_table":
        var extraProps = JSON.parse(field_meta);
  
        component = (
          <EditableRecordFields
            title={extraProps.title}
            columns={extraProps.columns}
          />
        );
        break;

      

      case "custom_opreation_plan":
  
        component = (
          <OperationPlanInput source={source_name} label="الخطة التشغيلية الميدانية للسائق" />
        );
        break;

        case "custom_opreation_plan_multi":
  
        component = (
          <OperationPlanMultiInput source={source_name} field_meta={field_meta} />
        );
        break;

        case "custom_opreation_plan_multi_field":
  
        component = (
          <OperationPlanMultiField source={source_name} field_meta={field_meta} />
        );
        break;

        case "custom_opreation_plan_field":
  
        component = (
          <OperationPlanField source={source_name} label="الخطة التشغيلية الميدانية للسائق" />
        );
        break;

        case "custom_blacklisted_driver_plan":
  
        component = (
          <BlacklistedDriverInput source={source_name} label="الخطة التشغيلية الميدانية للسائق/المرافق" />
        );
        break;

        case "custom_blacklisted_driver_plan_field":
  
        component = (
          <BlacklistedDriverField source={source_name} label="الخطة التشغيلية الميدانية للسائق/المرافق" />
        );
        break;

        

        case "custom_kml_preview":
  
        component = (
          <KMLPreview source={source_name} />
        );
        break;
   
        case "text_group_input_depend":
          ({ choices, component } = textQInputDepend(
            choices,
            field_meta,
            component,
            source_name,
            index,
            css_class,
            is_required
          ));
          break;
          case "radio_button_group_input_depend":
            ({ choices, component } = radioButtonGroupInputDepend(
              choices,
              field_meta,
              component,
              source_name,
              index,
              css_class,
              is_required
            ));
            break;
          case "select_create_input_depend":
            ({ component } = textQAutoCompleteInputDepend(
              choices,
              field_meta,
              component,
              source_name,
              index,
              css_class,
              is_required
            ));
            break;

            case "text_boolean_filter_main":
              var choicesx = [];
            
              try {
                // Ensure `field_meta` is a valid JSON string before parsing
                choicesx = field_meta && typeof field_meta === "string" ? JSON.parse(field_meta) : [];
              } catch (error) {
                console.error("Error parsing field_meta:", error);
                choicesx = []; // Fallback to an empty array to prevent errors
              }
            
              component = (
                <SelectInput
                  source={source_name}
                  fullWidth
                  key={index}
                  validate={is_required ? [required()] : undefined}
                  choices={Array.isArray(choicesx) ? choicesx : []} // Ensure choices is always an array
                  className={css_class}
                />
              );
              break;
            
  
  
              case "custom_plate_filter":
                component = (
                   <CarPlateFilter
                          source={source_name}
                          label="رقم اللوحة"
                          fullWidth
                          arabic
                          type={"transport"}
                          onChange={(newValue) => console.log("Updated Value:", newValue)}
                          sx={{ flex: '0 0 30%' }} // Set the CarPlateInput to take 50% of the width
                        />
  
                );
                break;

                case "date_input_filter":
                  component = dateInputFilter(
                    component,
                    source_name,
                    index,
                    css_class,
                    full_width,
                    disabled,
                    field_meta
                  );
                  break;


                  case 'reports_menu_field':
  component = ReportsMenuField(component, source_name, index, css_class, field_meta);
  break;

    case "sortable_text_array_input":
      var extraProps = field_meta ? JSON.parse(field_meta) : {};
      component = (
        <ArrayInput 
          source={source_name} 
          label={extraProps.label || "القائمة"}
          validate={is_required ? [required()] : undefined}
        >
          <SimpleFormIterator 
            inline 
            disableReordering={false}
            fullWidth
          >
            <TextInput 
              source={extraProps.itemField || "value"} 
              label={extraProps.itemLabel || "النص"}
              fullWidth
              validate={is_required ? [required()] : undefined}
            />
          </SimpleFormIterator>
        </ArrayInput>
      );
      break;

    case "sortable_text_array_field":
      var extraProps = field_meta ? JSON.parse(field_meta) : {};
      component = (
        <ArrayField 
          source={source_name} 
          label={extraProps.label || "القائمة"}
        >
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <FunctionField 
              label="#" 
              render={(record, index) => index + 1}
              textAlign="center"
            />
            <TextField 
              source={extraProps.itemField || "value"} 
              label={extraProps.itemLabel || "النص"}
            />
          </Datagrid>
        </ArrayField>
      );
      break;

    default:
      break;
  }
  return component;
};

function questionArrayInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let deepmetaReference = meta[3];
  let deepReferancesRourceName = meta[4];
  let deepmetaReferancesSource = meta[5];
  component = (
    <ArrayInput source={source_name}>
      <SimpleFormIterator>
        <ReferenceInput
          perPage={5000}
          source={referancesRourceName}
          reference={reference}
          key={index}
        >
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText={referancesSource}
          />
        </ReferenceInput>

        <ReferenceInput
          perPage={5000}
          source={deepReferancesRourceName}
          reference={deepmetaReference}
          key={index}
        >
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText={deepmetaReferancesSource}
          />
        </ReferenceInput>

        <NumberInput
          source="sort_score"
          defaultValue="1"
          className={`input-field ${css_class}  `}
        />
        <NumberInput
          source="report8_code"
          defaultValue="0"
          className={`input-field ${css_class}  `}
        />

        <BooleanInput
          source="is_mandatory"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />

        <BooleanInput
          source="violation_form8"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />

        <BooleanInput
          source="need_processing"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />

        <BooleanInput
          source="need_pic_proof"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />
        <BooleanInput
          source="need_pic_proof_vendor"
          label="صورة الاثبات  للمتعهد"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />
        <BooleanInput
          source="is_sensors_supported"
          label="هل يدعم الحساسات"
          k
          key={index}
          defaultValue={false}
          className={`input-field ${css_class}  `}
        />
        <BooleanInput
          source="is_choice_auto"
          label="هل اختيار الاجاية اتوماتيكي"
          k
          key={index}
          defaultValue={false}
          className={`input-field ${css_class}  `}
        />

        <NumberInput
          source="number_of_sensors"
          label="عدد الحساسات"
          defaultValue="0"
          className={`input-field ${css_class}  `}
        />
        <NumberInput
          source="range_max_validation"
          label="اعلى قيمة"
          defaultValue="0"
          className={`input-field ${css_class}  `}
        />
        <NumberInput
          source="range_min_validation"
          label="اقل قيمة"
          defaultValue="0"
          className={`input-field ${css_class}  `}
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function answerSetInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  let deepmetaReference = meta[0];
  let deepReferancesRourceName = meta[1];
  let deepmetaReferancesSource = meta[2];
  component = (
    <ArrayInput source="answers_settings">
      <SimpleFormIterator>
        <ReferenceInput
          source={deepReferancesRourceName}
          reference={deepmetaReference}
          key={index}
        >
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText={deepmetaReferancesSource}
          />
        </ReferenceInput>
        <ColorInput
          source="color"
          picker="Sketch"
          className={`input-field  ${css_class}  `}
        />

        <NumberInput
          source="timeout_in_days"
          key={index}
          className={`input-field ${css_class}  `}
        />

        <TextInput source="score" className={`input-field  ${css_class}  `} />
        <BooleanInput
          source="timeout_enable"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />

        <BooleanInput
          source="exclude_vehicle"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />
        <BooleanInput
          source="enable_score"
          key={index}
          defaultValue={true}
          className={`input-field  ${css_class}  `}
        />
        <BooleanInput
          source="is_answer_need_processing"
          key={index}
          defaultValue={true}
          className={`input-field ${css_class}  `}
        />
        <NumberInput
          source="range_min"
          label="اقل قيمة للحساسات"
          defaultValue="0"
          key={index}
          className={`input-field ${css_class}  `}
        />
        <NumberInput
          source="range_max"
          label="اعلى قيمة للحساسات"
          defaultValue="0"
          key={index}
          className={`input-field ${css_class}  `}
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function schoolPlanInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  component = (
    <ArrayInput
      source={source_name}
      validate={is_required ? [required()] : undefined}
    >
      <SimpleFormIterator>
        <ReferenceInput
          source="type_id"
          reference="domain_examination_types"
          key={index}
        >
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText="type"
          />
        </ReferenceInput>

        <ReferenceInput
          source="contractor_id"
          reference="domain_contractors"
          key={index}
        >
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText="name"
          />
        </ReferenceInput>

        <FormDataConsumer>
          {({
            formData, // The whole form data
            scopedFormData, // The data for this item of the ArrayInput
            getSource, // A function to get the valid source inside an ArrayInput
            ...rest
          }) => (
            <>
              <ReferenceInput
                source={getSource("contract_id")}
                filter={{
                  operator_id:
                    typeof scopedFormData !== "undefined"
                      ? scopedFormData.contractor_id
                      : null,
                }}
                reference="domain_contracts"
                key={index}
              >
                <SelectInput
                  className={`input-field ${css_class}  `}
                  label="resources.schools.fields.contract_id"
                  optionText="contract_number"
                />
              </ReferenceInput>
            </>
          )}
        </FormDataConsumer>
        <TextInput source="assigned" className={`input-field ${css_class}  `} />
        <TextInput
          source="allocated"
          className={`input-field ${css_class}  `}
        />

        <ArrayInput source="buses">
          <SimpleFormIterator>
            <ReferenceInput source="bus_id" reference="bus" key={index}>
              <SelectInput
                className={`input-field ${css_class}  `}
                optionText="bus_number"
              />
            </ReferenceInput>

            <SelectInput
              source="no_of_rounds"
              choices={[
                { id: "first_round", name: "رد" },
                { id: "second_round", name: "ردين" },
              ]}
              className={`input-field ${css_class}  `}
            />
            <TextInput
              source="seat_number_first_round"
              className={`input-field ${css_class}  `}
            />
            <TextInput
              source="seat_number_second_round"
              className={`input-field ${css_class}  `}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function colorInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  let deepmetaReference = meta[0];
  let deepReferancesRourceName = meta[1];
  let deepmetaReferancesSource = meta[2];
  component = (
    <ColorInput
      source={source_name}
      picker="Sketch"
      className={`input-field  ${css_class}  `}
    />
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function busSchoolPlanInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  component = (
    <ArrayInput
      source={source_name}
      validate={is_required ? [required()] : undefined}
    >
      <SimpleFormIterator>
        <ReferenceInput
          source="type_id"
          reference="domain_examination_types"
          key={index}
        >
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText="type"
          />
        </ReferenceInput>
        <ReferenceInput source="school_id" reference="schools" key={index}>
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText="name"
          />
        </ReferenceInput>

        <ReferenceInput
          source="contractor_id"
          reference="domain_contractors"
          key={index}
        >
          <SelectInput
            className={`input-field ${css_class}  `}
            optionText="name"
          />
        </ReferenceInput>

        <FormDataConsumer>
          {({
            formData, // The whole form data
            scopedFormData, // The data for this item of the ArrayInput
            getSource, // A function to get the valid source inside an ArrayInput
            ...rest
          }) => (
            <>
              <ReferenceInput
                source={getSource("contract_id")}
                filter={{
                  operator_id:
                    typeof scopedFormData !== "undefined"
                      ? scopedFormData.contractor_id
                      : null,
                }}
                reference="domain_contracts"
                key={index}
              >
                <SelectInput
                  className={`input-field ${css_class}  `}
                  label="resources.schools.fields.contract_id"
                  optionText="contract_number"
                />
              </ReferenceInput>
            </>
          )}
        </FormDataConsumer>
        <SelectInput
          source="no_of_rounds"
          choices={[
            { id: "first_round", name: "رد" },
            { id: "second_round", name: "ردين" },
          ]}
          className={`input-field ${css_class}  `}
        />
        <TextInput
          source="seat_number_first_round"
          className={`input-field ${css_class}  `}
        />
        <TextInput
          source="seat_number_second_round"
          className={`input-field ${css_class}  `}
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

// TODO
function questionSettingField(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  // meta = field_meta.split(".");
  // reference = meta[0];
  // referancesRourceName = meta[1];
  // referancesSource = meta[2];
  component = (
    <ArrayField source={source_name}>
      <Datagrid>
        <ReferenceField
          link={false}
          source="question_id"
          reference="questions"
          key={index}
        >
          <TextField source="question_text" />
        </ReferenceField>
        <BooleanField
          source="need_pic_proof"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="need_processing"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="violation_form8"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="is_mandatory"
          key={index}
          className={`show-field ${css_class}`}
        />
        <ReferenceField
          link={false}
          source="answer_set_id"
          reference="answer_sets"
          key={index}
        >
          <TextField source="description" />
        </ReferenceField>
        <ReferenceField
          link={false}
          source="answer_set_id"
          reference="answer_sets"
          key={index}
        >
          <ArrayField source="answers_settings">
            <Datagrid>
              <ReferenceField
                link={false}
                source="answer_id"
                reference="answers"
                key={index}
              >
                <TextField source="answer_text" />
              </ReferenceField>
              <BooleanField
                source="timeout_enable"
                key={index}
                className={`show-field ${css_class}`}
              />
              <BooleanField
                source="exclude_vehicle"
                key={index}
                className={`show-field ${css_class}`}
              />
              <TextField source="timeout_in_days" />
            </Datagrid>
          </ArrayField>
        </ReferenceField>
      </Datagrid>
    </ArrayField>
  );
  return component;
}

function answerSettingField(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  component = (
    <ArrayField source="answers_settings">
      <Datagrid>
        <ReferenceField
          link={false}
          source={referancesRourceName}
          reference={reference}
          key={index}
        >
          <TextField source={referancesSource} />
        </ReferenceField>
        <BooleanField
          source="timeout_enable"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="exclude_vehicle"
          key={index}
          className={`show-field ${css_class}`}
        />
        <TextField source="timeout_in_days" />
      </Datagrid>
    </ArrayField>
  );
  return component;
}

function schoolPlanField(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  // meta = field_meta.split(".");
  // reference = meta[0];
  // referancesRourceName = meta[1];
  // referancesSource = meta[2];
  component = (
    <ArrayField source={source_name}>
      <Datagrid>
        <ReferenceField
          link={false}
          source="contract_id"
          reference="domain_contracts"
          key={index}
        >
          <TextField source="contract_number" />
        </ReferenceField>

        <ReferenceField
          link={false}
          source="contractor_id"
          reference="domain_contractors"
          key={index}
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="allocated" />
        <TextField source="assigned" />

        <ReferenceField
          link={false}
          source="type_id"
          reference="domain_examination_types"
          key={index}
        >
          <TextField source="type" />
        </ReferenceField>

        <ArrayField source="buses">
          <Datagrid>
            <ReferenceField
              link={false}
              source="bus_id"
              reference="bus"
              key={index}
            >
              <TextField source="bus_number" />
            </ReferenceField>
            <TextField source="no_of_rounds" />
            <TextField source="seat_number_first_round" />
            <TextField source="seat_number_second_round" />
          </Datagrid>
        </ArrayField>
      </Datagrid>
    </ArrayField>
  );
  return component;
}

function busSchoolPlanField(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  // meta = field_meta.split(".");
  // reference = meta[0];
  // referancesRourceName = meta[1];
  // referancesSource = meta[2];
  component = (
    <ArrayField source={source_name}>
      <Datagrid>
        <ReferenceField
          link={false}
          source="type_id"
          reference="domain_examination_types"
          key={index}
        >
          <TextField source="type" />
        </ReferenceField>

        <ReferenceField
          link={false}
          source="school_id"
          reference="schools"
          key={index}
        >
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField
          link={false}
          source="contract_id"
          reference="domain_contracts"
          key={index}
        >
          <TextField source="contract_number" />
        </ReferenceField>

        <ReferenceField
          link={false}
          source="contractor_id"
          reference="domain_contractors"
          key={index}
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="no_of_rounds" />
        <TextField source="seat_number_first_round" />
        <TextField source="seat_number_second_round" />
      </Datagrid>
    </ArrayField>
  );
  return component;
}

function questionImage(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  // meta = field_meta.split(".");
  // reference = meta[0];
  // referancesRourceName = meta[1];
  // referancesSource = meta[2];
  component = (
    <ArrayField source={source_name}>
      <Datagrid>
        <ImageField source="url" className={`image-field-container `} />
      </Datagrid>
    </ArrayField>
  );
  return component;
}

function referencePlate(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  //console.log('>>>>', reference, referancesRourceName, referancesSource);
  component = (
    <ReferenceField
      link={false}
      source={referancesRourceName}
      reference={reference}
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <FunctionField
        label={referancesSource}
        render={(record) =>
          `${record.plate_number} ${record.plate_symbol3} ${record.plate_symbol2} ${record.plate_symbol1}    / (${record.seat_capacity} مقعد) - (${record.make_year}) `
        }
      />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function referenceFieldDepenancyInputSearchMultiFilter(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width,
  is_required,
  source_name
) {
  meta = field_meta.split(".");
  reference = meta[8];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let filterForeignKey = meta[3];
  let filterSearchKeyWordValue = meta[4];

  let filterForeignKey2 = meta[5];
  let filterSearchKeyWordValue2 = meta[6];
  //console.log(full_width);

  component = (
    <ReferenceInput
      perPage={5000}
      source={source_name}
      reference={reference}
      key={index}
    >
      <SelectInput
        className={`input-field ${css_class}  `}
        optionText={referancesSource}
        validate={is_required ? [required()] : undefined}
      />
    </ReferenceInput>
  );

  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}

function target_schools(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  component = (
    <ReferenceInput
      source="target_schools"
      reference="schools"
      key={index}
      perPage={5000}

    // filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
    >
      <TextField className={`input-field ${css_class}  `} />
    </ReferenceInput>
  );
  return component;
}
function target_inspectors(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <>
          <ReferenceInput
            source="target_inspectors"
            reference="employees_as_rows"
            key={index}
            perPage={5000}
            // fullWidth={true}

            filter={{ sub_zone_id: formData["administration_id"] }}
          >
            <TextField
              className={`input-field ${css_class}  `}
              fullWidth={true}
            />
          </ReferenceInput>
        </>
      )}
    </FormDataConsumer>
  );
  return component;
}

const FullNameField = ({ record = {} }) => (
  <span>
    {" "}
    {record.note != "" && record.note != null && <Description />}{" "}
    {record.images && record.images.length > 0 && <PhotoCamera />}
  </span>
);
FullNameField.defaultProps = { label: "المرفقات" };

function iconQuestions(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  component = (
    // <FullNameField source='id' />
    <FullNameField />
  );
  return component;
}

function referenceNoteCount(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  //console.log('>>>>', reference, referancesRourceName, referancesSource);
  component = (
    <ReferenceField
      sortable={false}
      link={false}
      source="id"
      label="الملاحظات"
      reference="inspection_statistics"
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <TextField source="total_notes" />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function referencePhotoCount(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  //console.log('>>>>', reference, referancesRourceName, referancesSource);
  component = (
    <ReferenceField
      link={false}
      sortable={false}
      source="id"
      label="الصور"
      reference="inspection_statistics"
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <TextField source="total_image" />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

const Small = styled('div')({
  color: 'black',
});

const Big = styled('div')({
  color: 'red',
});

const colored = (WrappedComponent) => (props) => {
  const Wrapper = props.record[props.source] === 'نعم' ? Big : Small;

  return (
    <Wrapper>
      <WrappedComponent {...props} />
    </Wrapper>
  );
};


const ColoredNumberField = colored(NumberField);
// Ensure the original component defaultProps are still applied as they may be used by its parents (such as the `Show` component):
ColoredNumberField.defaultProps = NumberField.defaultProps;

function referenceIsExclude(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  //console.log('>>>>', reference, referancesRourceName, referancesSource);
  component = (
    <ReferenceField
      link={false}
      sortable={false}
      source="id"
      label="يؤدى للاستبعاد"
      reference="inspection_statistics"
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <ColoredNumberField source="total_exclude" />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function serviceInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];

  component = (
    <ArrayInput
      fullWidth={true}
      key={index}
      className={`input-field ${css_class}  `}
      source="service_notes"
    >
      <SimpleFormIterator
        key={index}
        className={`input-field ${css_class}  `}
        disableAdd
        disableRemove
      >
        <TextInput
          disabled
          key={index}
          className={`input-field ${css_class}  `}
          source="classification"
        />
        <TextInput
          disabled
          key={index}
          className={`input-field ${css_class}  `}
          source="total"
        />
        <TextInput
          disabled
          key={index}
          className={`input-field ${css_class}  `}
          source="is_solved"
        />
        <TextInput
          disabled
          key={index}
          className={`input-field ${css_class}  `}
          source="per"
        />
        <TextInput
          validate={[required()]}
          key={index}
          className={`input-field ${css_class}  `}
          multiline
          source="recomendations"
        />
        <DateInput
          validate={[required()]}
          key={index}
          className={`input-field ${css_class}  `}
          source="due"
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function serviceShow(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];

  component = (
    <ArrayField
      fullWidth={true}
      key={index}
      className={`input-field ${css_class}  `}
      source="service_notes"
    >
      <Datagrid
        key={index}
        className={`input-field ${css_class}  `}
        disableRemove
      >
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="classification"
        />
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="total"
        />
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="is_solved"
        />
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="per"
        />
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          multiline
          source="recomendations"
        />
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="due"
        />
      </Datagrid>
    </ArrayField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function longTextInputRole1(
  component,
  source_name,
  index,
  css_class,
  is_required,
  full_width
) {
  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        formData.approve_status == "4" ? (
          <TextInput
            {...rest}
            multiline
            validate={is_required ? [required()] : undefined}
            fullWidth={full_width}
            source={source_name}
            key={index}
            className={`input-field ${css_class}  `}
          />
        ) : (
          <TextField
            {...rest}
            multiline
            validate={is_required ? [required()] : undefined}
            fullWidth={full_width}
            source={source_name}
            key={index}
            className={`input-field ${css_class}  `}
          />
        )
      }
    </FormDataConsumer>
  );

  return component;
}

function longTextInputRole2(
  component,
  source_name,
  index,
  css_class,
  is_required,
  full_width
) {
  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        formData.approve_status == "5" ? (
          <TextInput
            {...rest}
            multiline
            validate={is_required ? [required()] : undefined}
            fullWidth={full_width}
            source={source_name}
            key={index}
            className={`input-field ${css_class}  `}
          />
        ) : (
          <TextField
            {...rest}
            multiline
            validate={is_required ? [required()] : undefined}
            fullWidth={full_width}
            source={source_name}
            key={index}
            className={`input-field ${css_class}  `}
          />
        )
      }
    </FormDataConsumer>
  );

  return component;
}

function approvalInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];

  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        formData.approve_status == "2" && (
          <ArrayInput
            validate={[required()]}
            fullWidth={true}
            {...rest}
            key={index}
            className={`input-field ${css_class}  `}
            source="approved_by"
          >
            <SimpleFormIterator
              key={index}
              className={`input-field ${css_class}  `}
              disableRemove
            >
              <TextInput
                validate={[required()]}
                key={index}
                className={`input-field ${css_class}  `}
                source="name"
              />
              <TextInput
                validate={[required()]}
                key={index}
                className={`input-field ${css_class}  `}
                source="postion"
              />
              <RadioButtonGroupInput
                validate={[required()]}
                source="category"
                choices={[
                  { id: "company", name: "شركة تطوير" },
                  { id: "vendor", name: "المتعهد" },
                ]}
              />
            </SimpleFormIterator>
          </ArrayInput>
        )
      }
    </FormDataConsumer>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function approvalShow(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];

  component = (
    <ArrayField
      fullWidth={true}
      key={index}
      className={`input-field ${css_class}  `}
      source="approved_by"
    >
      <Datagrid
        fullWidth={true}
        key={index}
        className={`input-field ${css_class}  `}
        disableRemove
      >
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="name"
        />
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="postion"
        />
        <SelectField
          source="category"
          choices={[
            { id: "company", name: "شركة تطوير" },
            { id: "vendor", name: "المتعهد" },
          ]}
        />
      </Datagrid>
    </ArrayField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function reportInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];

  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        formData.approve_status == "3" && (
          <ArrayInput
            validate={[required()]}
            key={index}
            className={`input-field ${css_class}  `}
            label="  المتطلبات غير المنجزة"
            source="report_not_done"
          >
            <SimpleFormIterator
              key={index}
              className={`input-field ${css_class}  `}
              disableRemove
            >
              <TextInput
                validate={[required()]}
                key={index}
                className={`input-field ${css_class}  `}
                label="المتطلب"
                source="proplem"
              />
              <TextInput
                validate={[required()]}
                key={index}
                className={`input-field ${css_class}  `}
                label="التصنيف"
                source="cat"
              />
              <RadioButtonGroupInput
                validate={[required()]}
                source="category"
                label="نسبه المعالجة"
                choices={[
                  { id: "complete", name: "تم المعالجة كليا" },
                  { id: "part", name: "تم المعالجة جزئيا" },
                  { id: "no", name: " لم يتم المعالجة " },
                ]}
              />
            </SimpleFormIterator>
          </ArrayInput>
        )
      }
    </FormDataConsumer>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}
function reportShow(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];

  component = (
    <ArrayField
      key={index}
      className={`input-field ${css_class}  `}
      source="report_not_done"
    >
      <Datagrid
        key={index}
        className={`input-field ${css_class}  `}
        disableRemove
      >
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="proplem"
        />
        <TextField
          key={index}
          className={`input-field ${css_class}  `}
          source="cat"
        />
        <SelectField
          source="category"
          choices={[
            { id: "complete", name: "تم الحل كليا" },
            { id: "part", name: "تم الحل جزئيا" },
            { id: "no", name: " لم يتم الحل " },
          ]}
        />
      </Datagrid>
    </ArrayField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function dateInput(
  component,
  source_name,
  index,
  css_class,
  full_width,
  is_required
) {
  component = (
    <DateInput
      validate={is_required ? [required()] : undefined}
      source={source_name}
      key={index}
      fullWidth={full_width}
      className={`input-field ${css_class}  `}
      options={{ format: "dd/MM/yyyy", timeZone: "Asia/Riyadh" }}
    />
  );
  return component;
}

function dateInput2(
  component,
  source_name,
  index,
  css_class,
  full_width,
  is_required
) {
  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        formData.approve_status == "2" && (
          <DateInput
            validate={is_required ? [required()] : undefined}
            source={source_name}
            key={index}
            fullWidth={full_width}
            className={`input-field ${css_class}  `}
            options={{ format: "dd/MM/yyyy", timeZone: "Asia/Riyadh" }}
          />
        )
      }
    </FormDataConsumer>
  );

  return component;
}

function referenceFailFieldInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  is_required
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  //console.log(meta[3] ? { [meta[3]]: meta[4] } : undefined);

  component = (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <ReferenceInput
          perPage={5000}
          source={referancesRourceName}
          reference={reference}
          filter={meta[3] ? { [meta[3]]: meta[4] } : undefined}
          key={index}
          className={`input-field ${css_class}  `}
        >
          <SelectInput
            optionText={referancesSource}
            validate={
              is_required && formData.approve_status != "2"
                ? [required()]
                : undefined
            }
          />
        </ReferenceInput>
      )}
    </FormDataConsumer>
  );

  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}
//busSchoolPlanField

const ShowMeetingField = () => {
  const post = useRecordContext();
  const userShowPage = `https://reports-api.tatweertransit.com/certificate_download/download?record_uuid=${post.course_uuid}`;

  if (post.workflow_subcategory == 11) {
    return (
      <a target="_blank" rel="noopener noreferrer" href={userShowPage}>
        تحميل كل شهادات التدريب{" "}
      </a>
    );
  } else {
    return null; // or any other placeholder component
  }
};

function showMeeting(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  component = <ShowMeetingField>تحميل كل شهادات التدريب </ShowMeetingField>;
  return component;
}

const ShowMeetingField2 = () => {
  const post = useRecordContext();
  const userShowPage = `https://reports-api.tatweertransit.com/certificate_download/download?record_uuid=${post.serial_number}`;

  if (post.is_attend == true && post.pass_status == true && post.online_pass_status == true) {
    return (
      <a target="_blank" rel="noopener noreferrer" href={userShowPage}>
        تحميل شهادة التدريب{" "}
      </a>
    );
  } else {
    return null; // or any other placeholder component
  }
};

function showMeeting2(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  component = <ShowMeetingField2>تحميل شهادة التدريب</ShowMeetingField2>;
  return component;
}

function GridInputExtended(
  component,
  source_name,
  index,
  css_class,
  field_meta
) {
  let extraProps = JSON.parse(field_meta);

  component = <GridInput  source={source_name} {...extraProps} />;

  return component;
}
function GridShowExtended(
  component,
  source_name,
  index,
  css_class,
  field_meta
) {
  let extraProps = JSON.parse(field_meta);

  component = <GridShow  source={source_name} {...extraProps} />;

  return component;
}

function referenceFieldInputNew(
  source_name,
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  is_required,
  disabled
) {
  let extraProps = JSON.parse(field_meta);

  //console.log(meta[3] ? { [meta[3]]: meta[4] } : undefined);
  
  component = (
    <ReferenceInput
      perPage={extraProps.limit}
      source={source_name}
      reference={extraProps.reference_resource}
      fullWidth
      //filter={meta[3] ? { [meta[3]]: meta[4] } : undefined}
      key={index}
      className={`input-field ${css_class}  `}
      sort={
        extraProps &&
        extraProps.sort_by && {
          field: extraProps.sort_by,
          order: extraProps.sort_order,
        }
      }
    >
      <SelectInput
        fullWidth
        disabled={disabled}

        optionText={extraProps.reference_source}
        validate={is_required ? [required()] : undefined}
      />
    </ReferenceInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}

function referenceTextNew(
  source_name,
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  let extraProps = JSON.parse(field_meta);

  //console.log('>>>>', reference, referancesRourceName, referancesSource);
  component = (
    <ReferenceField
      link={false}
      source={source_name}
      reference={extraProps.reference_resource}
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <TextField source={extraProps.reference_source} />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function referenceTextNewDisabled(
  source_name,
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  let extraProps = JSON.parse(field_meta);

  //console.log('>>>>', reference, referancesRourceName, referancesSource);
  component = (
    <ReferenceField
      link={false}
      source={source_name}
      reference={extraProps.reference_resource}
      key={index}
      className={`show-field ${css_class} ${className}`}
    >
      <TextField source={extraProps.reference_source} />
    </ReferenceField>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

function referenceTextNewDisabledSeperated(
  source_name,
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  className
) {
  let extraProps = JSON.parse(field_meta);
  const allowMulti = extraProps.allow_multi === true;
  const separator = extraProps.separator || '|';

  //console.log('>>>>', reference, referancesRourceName, referancesSource);
  
  if (allowMulti) {
    // Multi-select display: split by separator and show each value
    const MultiSelectField = () => {
      const record = useRecordContext();
      const value = record?.[source_name];
      
      if (!value) return null;
      
      const ids = typeof value === 'string' 
        ? value.split(separator).filter(v => v) 
        : (Array.isArray(value) ? value : []);
      
      if (ids.length === 0) return null;
      
      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {ids.map((id, idx) => (
            <ReferenceField
              key={idx}
              link={false}
              source={source_name}
              reference={extraProps.reference_resource}
              record={{ [source_name]: id }}
            >
              <Chip 
                label={<TextField source={extraProps.reference_source} />}
                size="small"
                sx={{ maxWidth: '200px' }}
              />
            </ReferenceField>
          ))}
        </Box>
      );
    };
    
    component = (
      <MultiSelectField key={index} className={`show-field ${css_class} ${className}`} />
    );
  } else {
    // Single-select display (existing behavior)
    component = (
      <ReferenceField
        link={false}
        source={source_name}
        reference={extraProps.reference_resource}
        key={index}
        className={`show-field ${css_class} ${className}`}
      >
        <TextField source={extraProps.reference_source} />
      </ReferenceField>
    );
  }
  
  return { meta, reference, referancesRourceName, referancesSource, component };
}


function excelInput(component, source_name, index, css_class) {
  component = (
    <FileInput
      source={source_name}
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      key={index}
      className={`input-field ${css_class}  `}
    >
      <UrlField source="src" />
    </FileInput>
  );
  return component;
}

function excelField(extraProps, component, source_name, index, css_class) {
  component = (
    <FileField source={extraProps} title="اضغط لتحميل ملف  Excel">
      {" "}
    </FileField>
  );
  return component;
}

function customAclsInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  component = (
    <ArrayInput fullWidth source={source_name}>
      <SimpleFormIterator inline disableReordering fullWidth>
        <BooleanInput source="show" key={index} defaultValue={true} />

        <BooleanInput source="add" key={index} defaultValue={true} />

        <BooleanInput source="edit" key={index} defaultValue={true} />

        <BooleanInput source="delete" key={index} defaultValue={true} />

        <ReferenceInput
          perPage={200}
          source="module"
          reference="acls_modules"
          key={index}
        >
          <SelectInput optionText="title" />
        </ReferenceInput>
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

// TODO
function customAclsShow(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  // meta = field_meta.split(".");
  // reference = meta[0];
  // referancesRourceName = meta[1];
  // referancesSource = meta[2];
  component = (
    <ArrayField source={source_name}>
      <Datagrid>
        <ReferenceField
          source="module"
          label="module"
          reference="acls_modules"
          key={index}
        >
          <TextField source="title" />
        </ReferenceField>
        <BooleanField
          source="show"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="add"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="edit"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="delete"
          key={index}
          className={`show-field ${css_class}`}
        />
      </Datagrid>
    </ArrayField>
  );
  return component;
}

function aclBusinessesInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  is_required
) {
  //console.log(meta[3] ? { [meta[3]]: meta[4] } : undefined);

  component = (
    <FormDataConsumer className={"input-field inlineCustom"} >
      {({ formData, ...rest }) => (
        <>
          <BooleanInput
            className={"input-field inlineCustom"}
            source="businesses.all"
            disabled={
              formData.user_type != "admin" &&
              formData.user_type != "rafed" &&
              true
            }
            defaultValue={false}
          />

          <ReferenceArrayInput
            source="businesses.list"
            reference="businesses"
            perPage={200}
            validate={
              formData.user_type != "admin" && formData.user_type != "rafed"
                ? [required()]
                : undefined
            }
            className={"input-field inlineCustom"}
          >
            <SelectArrayInput>
              <ChipField source="name" />
            </SelectArrayInput>
          </ReferenceArrayInput>
        </>
      )}
    </FormDataConsumer>
  );
  return component;
}

function aclSchoolsInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  is_required
) {
  //console.log(meta[3] ? { [meta[3]]: meta[4] } : undefined);

  component = (
    <FormDataConsumer className={"input-field inlineCustom"} >
      {({ formData, ...rest }) => (
        <>
          <BooleanInput
            className={"input-field inlineCustom"}
            source="schools.all"
            disabled={
              formData.user_type != "admin" &&
              formData.user_type != "rafed" &&
              true
            }
            defaultValue={false}
          />

          <ReferenceArrayInput
            source="schools.list"
            reference="schools"
            perPage={200}
            validate={
              formData.user_type != "admin" && formData.user_type != "rafed"
                ? [required()]
                : undefined
            }
            className={"input-field inlineCustom"}
          >
            <SelectArrayInput>
              <ChipField source="name" />
            </SelectArrayInput>
          </ReferenceArrayInput>
        </>
      )}
    </FormDataConsumer>
  );
  return component;
}

function aclRegionsInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  is_required
) {
  //console.log(meta[3] ? { [meta[3]]: meta[4] } : undefined);

  component = (
    <FormDataConsumer className={"input-field inlineCustom"} >
      {({ formData, ...rest }) => (
        <>
          <BooleanInput
            className={"input-field inlineCustom"}
            source="regions.all"
            disabled={
              formData.user_type != "admin" &&
              formData.user_type != "rafed" &&
              true
            }
            defaultValue={false}
          />

          <ReferenceArrayInput
            source="regions.list"
            reference="domains_regions"
            perPage={200}
            validate={
              formData.user_type != "admin" && formData.user_type != "rafed"
                ? [required()]
                : undefined
            }
            className={"input-field inlineCustom"}
          >
            <SelectArrayInput>
              <ChipField source="name" />
            </SelectArrayInput>
          </ReferenceArrayInput>
        </>
      )}
    </FormDataConsumer>
  );
  return component;
}

function aclContractorsInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  is_required
) {
  //console.log(meta[3] ? { [meta[3]]: meta[4] } : undefined);

  component = (
    <FormDataConsumer className={"input-field inlineCustom"} >
      {({ formData, ...rest }) => (
        <>
          {formData.user_type != "business_admin" &&
            formData.user_type != "business_employee" && (
              <BooleanInput
                className={"input-field inlineCustom"}
                source="contractors.all"
                disabled={
                  formData.user_type != "admin" &&
                  formData.user_type != "rafed" &&
                  true
                }
                defaultValue={false}
              />
            )}

          <ReferenceArrayInput
            source="contractors.list"
            reference="domains_contractors"
            perPage={200}
            validate={
              formData.user_type != "admin" && formData.user_type != "rafed"
                ? [required()]
                : undefined
            }
            className={"input-field inlineCustom"}
          >
            <SelectArrayInput>
              <ChipField source="name" />
            </SelectArrayInput>
          </ReferenceArrayInput>
        </>
      )}
    </FormDataConsumer>
  );
  return component;
}

function referenceFieldDepenancyInputSearchNew2(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width,
  is_required,
  source_name
) {
  let extraProps = JSON.parse(field_meta);

  //console.log(full_width);

  component = (
    <FormDataConsumer
      source={source_name}
      className={`input-field ${css_class}  `}
    >
      {({ formData, ...rest }) => (
        <>
          {!extraProps.extra_filter_column &&
            formData[extraProps.filter_column_exist] && (
              <ReferenceInput
                source={source_name}
                reference={extraProps.reference_resource}
                key={index}
                perPage={extraProps.limit}
                fullWidth
                //filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
                filter={{
                  [extraProps.filter_key]: formData[extraProps.filter_column],
                }}
                sort={
                  extraProps &&
                  extraProps.sort_by && {
                    field: extraProps.sort_by,
                    order: extraProps.sort_order,
                  }
                }
                //  filterToQuery={searchText => ({ [referancesSource]: searchText })}

                {...rest}
              >
                <SelectInput
                  fullWidth
                  optionText={extraProps.reference_source}
                  validate={is_required ? [required()] : undefined}
                />
              </ReferenceInput>
            )}
          {extraProps.extra_filter_column &&
            formData[extraProps.filter_column_exist] && (
              <ReferenceInput
                source={source_name}
                reference={extraProps.reference_resource}
                key={index}
                perPage={extraProps.limit}
                //filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
                filter={{
                  [extraProps.filter_key]: formData[extraProps.filter_column],
                  [extraProps.extra_filter_column]:
                    extraProps.extra_filter_value,
                }}
                sort={
                  extraProps &&
                  extraProps.sort_by && {
                    field: extraProps.sort_by,
                    order: extraProps.sort_order,
                  }
                }
                //  filterToQuery={searchText => ({ [referancesSource]: searchText })}

                {...rest}
              >
                <SelectInput
                  optionText={extraProps.reference_source}
                  validate={is_required ? [required()] : undefined}
                />
              </ReferenceInput>
            )}
        </>
      )}
    </FormDataConsumer>
  );

  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}


function referenceFieldDepenancyInputSearchNew2Filter(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width,
  is_required,
  source_name
) {
  let extraProps = JSON.parse(field_meta);

  //console.log(full_width);

  component = (
    <FormDataConsumer
      source={source_name}
      className={`input-field ${css_class}  `}
    >
      {({ formData, ...rest }) => (
        <>
          
              <ReferenceInput
                source={source_name}
                reference={extraProps.reference_resource}
                key={index}
                perPage={extraProps.limit}
                fullWidth
                //filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
           
                sort={
                  extraProps &&
                  extraProps.sort_by && {
                    field: extraProps.sort_by,
                    order: extraProps.sort_order,
                  }
                }
                //  filterToQuery={searchText => ({ [referancesSource]: searchText })}

                {...rest}
              >
                <SelectInput
                  fullWidth
                  optionText={extraProps.reference_source}
                  validate={is_required ? [required()] : undefined}
                />
              </ReferenceInput>
          
        
        </>
      )}
    </FormDataConsumer>
  );

  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}


function referenceFieldDepenancyInputSearchNew(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width,
  is_required,
  source_name
) {
  let extraProps = JSON.parse(field_meta);

  //console.log(full_width);

  component = (
    <FormDataConsumer      source={source_name}   className={`input-field ${css_class}  `}  >
      {({ formData, ...rest }) => (
        <>
          {extraProps.filter_column_exist &&
            formData[extraProps.filter_column_exist] && (
              <ReferenceInput
                source={source_name}
                reference={extraProps.reference_resource}
                key={index}
                perPage={extraProps.limit}
                //filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
                filter={{
                  [extraProps.filter_key]: formData[extraProps.filter_column],
                }}
                filterToQuery={(searchText) => ({
                  [extraProps.reference_source]: searchText,
                })}
                {...rest}
              >
                <AutocompleteInput
                  optionText={extraProps.reference_source}
                  filterToQuery={(searchText) => ({
                    [extraProps.reference_source]: `%${searchText}%`,
                  })}
                  validate={is_required ? [required()] : undefined}
                />
              </ReferenceInput>
            )}
          {!extraProps.filter_column_exist && (
            <ReferenceInput
              source={source_name}
              reference={extraProps.reference_resource}
              key={index}
              perPage={extraProps.limit}
              //filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
              filter={{
                [extraProps.filter_key]: formData[extraProps.filter_column],
              }}
              filterToQuery={(searchText) => ({
                [extraProps.reference_source]: searchText,
              })}
              {...rest}
            >
              <AutocompleteInput
                filterToQuery={(searchText) => ({
                  [extraProps.reference_source]: `%${searchText}%`,
                })}
                optionText={extraProps.reference_source}
                validate={is_required ? [required()] : undefined}
              />
            </ReferenceInput>
          )}
        </>
      )}
    </FormDataConsumer>
  );

  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}

function referenceFieldDepenancyInputSearchNew3(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width,
  is_required,
  source_name
) {
  let extraProps = JSON.parse(field_meta);

  const filterToQuery = (searchText) => ({
    [extraProps.reference_source]: `%${searchText}%`,
  });

  //console.log(full_width);

  component = (
    <FormDataConsumer
      source={source_name}
      className={`input-field ${css_class}  `}
    >
      {({ formData, ...rest }) => (
        <>
          {extraProps.filter_column_exist &&
            formData[extraProps.filter_column_exist] && (
              <ReferenceInput
                source={source_name}
                reference={extraProps.reference_resource}
                key={index}
                perPage={extraProps.limit}
                //filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
                filter={{
                  [extraProps.filter_key]: formData[extraProps.filter_column],
                }}
                filterToQuery={(searchText) => ({
                  [extraProps.reference_source]: searchText,
                })}
                {...rest}
              >
                <AutocompleteInput
                  optionText={extraProps.reference_source}
                  filterToQuery={(searchText) => ({
                    [extraProps.reference_source]: `%${searchText}%`,
                  })}
                  validate={is_required ? [required()] : undefined}
                />
              </ReferenceInput>
            )}
          {!extraProps.filter_column_exist && (
            <ReferenceInput
              source={source_name}
              reference={extraProps.reference_resource}
              perPage={extraProps.limit}
            >
              <AutocompleteInput filterToQuery={filterToQuery} />
            </ReferenceInput>
          )}
        </>
      )}
    </FormDataConsumer>
  );

  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}

function mapInput(component, index, source_name, css_class,is_required) {
  component = (
    <GoogleMapsInput source={source_name}               validate={is_required ? [required()] : undefined} />)

  return component;
}

function referenceFieldDepenancyInputSearchSelect(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class,
  full_width,
  is_required,
  source_name
) {
  meta = field_meta.split(".");
  reference = meta[0];
  referancesRourceName = meta[1];
  referancesSource = meta[2];
  let filterForeignKey = meta[3];
  let filterSearchKeyWordValue = meta[4];

  let extraProps = JSON.parse(field_meta);

  //console.log(full_width);

  component = (
    <FormDataConsumer
      source={source_name}
      className={`input-field ${css_class}  `}
    >
      {({ formData, ...rest }) => (
        <>
          <ReferenceInput
            source={source_name}
            reference={extraProps.reference_resource}
            key={index}
            perPage={5000}
            //filter={{ [filterForeignKey]: formData[filterSearchKeyWordValue] }}
            filter={{
              [extraProps.filter_key]: formData[extraProps.filter_column],
            }}
            //filterToQuery={(searchText) => ({ [extraProps.reference_source]: searchText })}
            {...rest}
          >
            <SelectInput
              optionText={extraProps.reference_source}
              validate={is_required ? [required()] : undefined}
            />
          </ReferenceInput>
        </>
      )}
    </FormDataConsumer>
  );

  return { meta, reference, referancesRourceName, referancesSource, component };
  //return component;
}

const ShowStatusField = ({ extraProps, source_name }) => {
  const record = useRecordContext();
  if (!record) return null;

  const status = record[source_name] || "default"; // Default to 'default' if status is undefined
  const statusConfig = extraProps[status] || {}; // Get the configuration for the status

  const backgroundColor = statusConfig.backgroundColor || "";
  const textColor = statusConfig.textColor || "";
  const label = statusConfig.label || status;

  // Define styles for the Chip
  const chipStyle = {
    backgroundColor,
    color: textColor,
  };

  return (
    <Chip
      label={label}
      size="small"
      style={chipStyle} // Apply the style here
    />
  );
};


function ReportsMenuField(component, source_name, index, css_class, field_meta) {
  if (!field_meta) return null;
  let extraProps = {};
  try {
    extraProps = JSON.parse(field_meta);
  } catch (e) {
    console.error('Invalid field_meta JSON for ReportsMenuField:', e);
    return null;
  }
  return <ShowReportsMenuField extraProps={extraProps} source_name={source_name} />;
}

function StatusField(component, source_name, index, css_class, field_meta) {
  if (!field_meta) return null;

  let extraProps = JSON.parse(field_meta);

  return <ShowStatusField extraProps={extraProps} source_name={source_name} />;
}

function customAttachmentsInput(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  component = (
    <ArrayInput fullWidth source={source_name}>
      <SimpleFormIterator inline disableReordering fullWidth>
        <ReferenceInput
          perPage={200}
          source="course_type"
          reference="course_types"
          key={index}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>

        <TextInput source="file_name" />
      </SimpleFormIterator>
    </ArrayInput>
  );
  return { meta, reference, referancesRourceName, referancesSource, component };
}

// TODO
function customAttachmentsShow(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  // meta = field_meta.split(".");
  // reference = meta[0];
  // referancesRourceName = meta[1];
  // referancesSource = meta[2];
  component = (
    <ArrayField source={source_name}>
      <Datagrid>
        <ReferenceField
          source="course_type"
          label="course_type"
          reference="course_types"
          key={index}
        >
          <TextField source="name" />
        </ReferenceField>
        <BooleanField
          source="show"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="add"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="edit"
          key={index}
          className={`show-field ${css_class}`}
        />
        <BooleanField
          source="delete"
          key={index}
          className={`show-field ${css_class}`}
        />
      </Datagrid>
    </ArrayField>
  );
  return component;
}

const ShowGoogleMaps = ({source_name}) => {
  const post = useRecordContext();
          const resource = useResourceContext();
                  const translate = useTranslate();
          
  

  if (post[source_name]) {
    // Extract latitude and longitude from the JSONB data
    const { lat, lng } = post[source_name];

    // Create the Google Maps link
    const userShowPage = `https://www.google.com/maps?q=${lat},${lng}`;

    return (
      <a target="_blank" rel="noopener noreferrer" href={userShowPage}>
        مشاهدة  {translate(`resources.${resource}.fields.${source_name}`)} علي جوجل ماب
      </a>
    );
  } else {
    return "--";
  }
};

const ShowCourceLink = () => {
  const post = useRecordContext();

  // Extract latitude and longitude from the JSONB data
  const { src } = post.file_url;

  // Create the Google Maps link

  return (
    <a target="_blank" rel="noopener noreferrer" href={src}>
      تحميل
    </a>
  );
};

function showCourse(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  component = <ShowCourceLink>تحميل </ShowCourceLink>;
  return component;
}

function showLocation(
  meta,
  field_meta,
  source_name,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  index,
  css_class
) {
  component = <ShowGoogleMaps source_name={source_name}>الموقع علي الخريطة</ShowGoogleMaps>;
  return component;
}

function referenceResourceBulkAction(
  field_meta,
  component,
  index,
  record,
  f,
  id
) {
  //console.log("field_meta", field_meta);
  const metaData = JSON.parse(field_meta);

  const limit = metaData.limit || 5000;

  const role = localStorage.getItem("role");
  let resource = metaData.reference;

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
  });

  const PostBulkUpdateButton = ({ statusId }) => {
    let inputs = [];
    //console.log(statusId);
    //console.log(role);

    if (
      statusId === 8 &&
      [
        "trainer",
        "saftysupervisortrainer",
        "admin",
        "areamangertrainer",
      ].includes(role)
    ) {
      inputs = [
         {
          label: "يوم الحضور",
          element: (
            <DateInput
              validate={[required()]}
              label="يوم الحضور"
              source="attendance_date"
            />
          ),
        },
        {
          label: "تحديث حالة الحضور",
          element: (
            <BooleanInput
              validate={[required()]}
              label="تم الحضور"
              source="is_attend"
            />
          ),
        },
        {
          label: "ملاحظات المدرب",
          element: (
            <TextInput
              source="instructor_notes"
              label="ملاحظات المدرب"
              multiline
              fullWidth
            />
          ),
        },
      ];
    } else if (
      statusId === 9 &&
      [
        "saftysupervisor",
        "safetysupervisor",
        "saftysupervisortrainer",
        "admin",
      ].includes(role)
    ) {
      inputs = [
        {
          label: "يوم الحضور",
          element: (
            <DateInput
              validate={[required()]}
              label="يوم الحضور"
              source="attendance_date"
            />
          ),
        },
        {
          label: "تحديث حالة الحضور",
          element: (
            <BooleanInput
              validate={[required()]}
              label="تم الحضور"
              source="is_attend"
            />
          ),
        }
/*         ,{
          label: "تحديث نتيجة الاختبار",
          element: (
            <BooleanInput
              validate={[required()]}
              label="تم تجاوز الاختبار"
              source="pass_status"
            />
          ),
        }, */
      ];
    } else {
      // Default inputs or for other status_id values
      inputs = [
        // ...
      ];
    }

    return (
      <BulkUpdateFormButton>
        <InputSelectorForm inputs={inputs} />
      </BulkUpdateFormButton>
    );
  };

  let resourcesFields = alasql(
    `
        select watched_column,source_name,field_widget_type, field_meta, css_class from resources 
        WHERE 
        resource_name ='${resource}' AND is_list_field =true  and is_expand_field=true 
        AND ( role_${role}='read' OR role_${role}='write' ) 
        `
  );

  let resourcesFieldsInput = alasql(
    `select distinct write_group as tab  from resources where resource_name ='${resource}'  and   is_inline=true `
  ).map(({ tab }) =>
    alasql(`select  watched_column,grid_class,grid_xs,grid_sm,is_require_separator,is_require_label,label_text,source_name, edit_input_widget_type as input_widget_type, field_meta , annotation, css_class, edit_css_class, full_width,is_required  from resources where write_group ="${tab}" and resource_name ='${resource}'  and is_edit_field =true
  AND ( role_${role}='write' ) and   is_inline=true `)
  );

  let tabs = alasql(
    `select distinct write_group as tab  from resources where resource_name ='${resource}'  and   is_inline=true   and   is_edit_field =true and  role_${role}='write' `
  ).map(({ tab }) => tab);

  const sqlRoleFields = generateSQLRoleFields(
    ["show", "edit", "delete"],
    roles
  );

  let resourcePermistions = alasql(
    `select is_expand,expand_resource, expand_source, expand_destination,list_is_tab,list_is_calendar,list_tabs,list_tab_filter,list_tab_filter_value,resource_name,inline_update,inline_create, 
    ${sqlRoleFields} from resource_permistions  where resource_name ='${resource}' `
  );

  if (resourcePermistions && resourcePermistions[0].list_is_tab) {
    resourcePermistions[0].list_tab_filter_value = parseInt(
      resourcePermistions[0].list_tab_filter_value
    );

    component = [
      <FormDataConsumer  className={`   `}>
        {({ formData, ...rest }) => (
          <>
            <ReferenceManyField
              addLabel={false}
              fullWidth
              reference={metaData.reference}
              target={metaData.target}
              perPage={limit} // Use the limit from metaData
              {...rest}
            >
              <TabedListGrid
                fullWidth
                resourcePermistions={resourcePermistions[0]}
                resourcesFields={resourcesFields}
              />
            </ReferenceManyField>
          </>
        )}
      </FormDataConsumer>,
    ];
  } else {
    component = [
      <FormDataConsumer  className={`   `}>
        {({ formData, ...rest }) => (
          <>
            <ReferenceManyField
              addLabel={false}
              reference={metaData.reference}
              target={metaData.target}
              pagination={<Pagination />}
              perPage={limit} // Use the limit from metaData
            >
              <DefaultListGrid
                bulkActionButtons={
                  <PostBulkUpdateButton
                    statusId={formData.workflow_subcategory}
                  />
                }
                resourcePermistions={resourcePermistions[0]}
                resourcesFields={resourcesFields}
              />
            </ReferenceManyField>{" "}
          </>
        )}
      </FormDataConsumer>,

      //<AddButton index={index} {...metaData} record={record} />
    ];
  }

  return component;
}

function reference_many_to_many_input(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  const metaData = JSON.parse(field_meta);

  component = (
    <ReferenceArrayInput
      source={source_name}
      reference={metaData.reference}
      perPage={200}
      validate={[required()]}
      className={"input-field inlineCustom"}
    >
      <SelectArrayInput>
        <ChipField source={metaData.text} />
      </SelectArrayInput>
    </ReferenceArrayInput>
  );

  return component;
}

// TODO
function reference_many_to_many_field(
  meta,
  field_meta,
  reference,
  referancesRourceName,
  referancesSource,
  component,
  source_name,
  index,
  css_class
) {
  const metaData = JSON.parse(field_meta);

  component = (
    <ReferenceArrayField
      source={source_name}
      reference={metaData.reference}
      perPage={200}
      validate={[required()]}
      className={"input-field inlineCustom"}
    >
      <SingleFieldList>
        <ChipField source={metaData.text} />
      </SingleFieldList>
    </ReferenceArrayField>
  );
  return component;
}

function VehicleMetaDataForm(meta) {
  const { disabled, VehicleMetaData } =
    useWatchVehicleInput("editingVehicleMeta"); // Use the custom hook
  const { driverMetaData } = useWatchDriverInput("editingDriverMeta"); // Use the custom hook

  const { source_name, index, is_required } = meta;

  if (!driverMetaData) {
    return null; // Render nothing if driverMetaData is undefined or null
  }
  // Return the TextInput component with the necessary props
  return (
    <Box sx={{ marginTop: 2 }}>

      <Typography variant="h6" gutterBottom>
        معلومات الحافلة
      </Typography>
      <Grid container spacing={1}>
      <Grid item size={{ xs: 2 }}>
      <CarPlateInput
            source={`${source_name}.plate_number`}
            label="رقم اللوحة"
            fullWidth
            arabic
            type={"transport"}
            onChange={(newValue) => console.log("Updated Value:", newValue)}
          />
        </Grid>
        <Grid item size={{ xs: 1 }}>
        <CarPlateField
            source={`${source_name}.plate_number`}
            label="رقم اللوحة"
            fullWidth
            arabic
            type={"transport"}
            showEnglish={true}
            onChange={(newValue) => console.log("Updated Value:", newValue)}
          />
        </Grid>

        <Grid item size={{ xs: 1 }}>
          <CarPlateField
            source={`${source_name}.plate_number`}
            label="رقم اللوحة"
            fullWidth
            arabic
            type={"transport"}
            showEnglish={false}
            onChange={(newValue) => console.log("Updated Value:", newValue)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1}>
      <Grid item size={{ xs: 2 }}>
      <TextInput
            source={`${source_name}.serial_number`}
            label="الرقم التسلسلى"
            fullWidth
            disabled={disabled}
          />
        </Grid>

        <Grid item size={{ xs: 1 }}>
          <TextInput
            source={`${source_name}.operation_number`}
            label="الرقم التشغيلي"
            fullWidth
            disabled={disabled}
          />
        </Grid>
        <Grid item size={{ xs: 2 }}>
          <TextInput
            source={`${source_name}.disability_type`}
            label="حالة الاعاقة"
            fullWidth
            disabled={disabled}
          />
        </Grid>
        <Grid item size={{ xs: 1 }}>
          <BooleanInput
            source={`${source_name}.is_sub_contractor`}
            label="متعهد باطن"
            disabled={disabled}
          />
        </Grid>
        <Grid item size={{ xs: 2 }}>
          <SelectInput
            fullWidth
            validate={is_required ? [required()] : undefined}
            source={`${source_name}.is_ods`}
            key={index}
            disabled={true} // Enable or disable based on your requirements
            choices={[
              { id: true, name: "نعم" },
              { id: false, name: "لا" },
            ]}
            optionText="name"
            optionValue="id"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

function textQInputDepend(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  // Parse the metadata JSON. It should include choices and optionally dependency info.
  const meta = JSON.parse(field_meta);

  // Use the choices provided in the meta

  // Optional dependency information
  const dependColumn = meta.depend;      // e.g., "students"
  const dependValue = meta.dependValue;    // e.g., "نعم"

  

  // Create the base RadioButtonGroupInput component
  const baseComponent = (
    <TextInput
    fullWidth={true}
    validate={is_required ? [required()] : undefined}
    source={source_name}
    key={index}
  />
  );

  // If dependency information is provided, wrap the base component with FormDataConsumer
  if (dependColumn && dependValue !== undefined) {
      component = (
          <FormDataConsumer key={index}>
              {({ formData, ...rest }) =>
                  formData[dependColumn] === dependValue
                      ? React.cloneElement(baseComponent, { ...rest })
                      : null
              }
          </FormDataConsumer>
      );
  } else {
      // Otherwise, just use the base component directly.
      component = baseComponent;
  }

  return { choices, component };
}

function textQAutoCompleteInputDepend(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  console.log(field_meta)
  const meta = JSON.parse(field_meta);
  const table_name = meta.reference_resource;
  const column_name = meta.reference_source;
  const id_name = meta.id;
  const dependColumn = meta.depend;
  const dependValue = meta.dependValue;
  const allowMulti = meta.allow_multi || false; // Check if multi-select is enabled
  const separator = meta.separator || '|'; // Default separator is comma, can be '|' or any other

  const [create] = useCreate();
  const notify = useNotify();

  const handleCreate = async (newOption) => {
    if (!newOption) return;
    try {
      const newRecord = await create(
        table_name,
        { data: { [column_name]: newOption } },
        { returnPromise: true }
      );
      return newRecord;
    } catch (error) {
      notify('An error occurred while creating the record', {
        type: 'error',
      });
      throw error;
    }
  };

  // Custom MultiSelectInput component for text storage
  const MultiSelectTextInput = () => {
    const { setValue, getValues } = useFormContext();
    const dataProvider = useDataProvider();
    const [choices, setChoices] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
      dataProvider.getList(table_name, {
        pagination: { page: 1, perPage: 5000 },
        sort: { field: 'id', order: 'ASC' }
      }).then(({ data }) => {
        setChoices(data);
        setLoading(false);
      });
    }, []);

    const currentValue = getValues(source_name);
    const parsedValue = currentValue 
      ? (typeof currentValue === 'string' ? currentValue.split(separator).filter(v => v.trim()) : currentValue)
      : [];

    const handleCreateMulti = async (filterValue) => {
      const newItem = {
        [column_name]: filterValue,
      };

      try {
        const { data } = await dataProvider.create(table_name, { data: newItem });
        setChoices([...choices, data]);
        return data;
      } catch (error) {
        console.error('Error creating new item:', error);
        return null;
      }
    };

    return (
      <AutocompleteArrayInput
        fullWidth
        source={source_name}
        choices={choices}
        optionText={column_name}
        optionValue="id"
        loading={loading}
        validate={is_required ? [required()] : undefined}
        onCreate={handleCreateMulti}
        parse={(value) => {
          if (!value || value.length === 0) return '';
          return value.join(separator);
        }}
        format={(value) => {
          if (!value) return [];
          if (Array.isArray(value)) return value;
          return value.toString().split(separator).filter(v => v.trim());
        }}
        filterToQuery={(searchText) => ({
          [column_name]: searchText,
        })}
        sx={{
          maxWidth: '100%',
          '& .MuiChip-root': {
            maxWidth: '200px'
          }
        }}
      />
    );
  };

  // Choose between single and multi-select
  const baseComponent = allowMulti ? (
    <MultiSelectTextInput />
  ) : (
    <ReferenceInput source={source_name} reference={table_name} key={index}>
      <AutocompleteInput 
        fullWidth 
        validate={is_required ? [required()] : undefined} 
        filterToQuery={(searchText) => ({ [column_name]: searchText })} 
        optionText={column_name} 
        onCreate={handleCreate} 
      />
    </ReferenceInput>
  );

  if (dependColumn && dependValue !== undefined) {
    component = (
      <FormDataConsumer key={index}>
        {({ formData, ...rest }) =>
          formData[dependColumn] === dependValue
            ? React.cloneElement(baseComponent, { ...rest })
            : null
        }
      </FormDataConsumer>
    );
  } else {
    component = baseComponent;
  }

  return { component };
}

function radioButtonGroupInputDepend(
  choices,
  field_meta,
  component,
  source_name,
  index,
  css_class,
  is_required
) {
  // Parse the metadata JSON. It should include choices and optionally dependency info.
  const meta = JSON.parse(field_meta);

  // Use the choices provided in the meta
  choices = meta.choices;

  // Optional dependency information
  const dependColumn = meta.depend;      // e.g., "students"
  const dependValue = meta.dependValue;    // e.g., "نعم"

  // Create the base RadioButtonGroupInput component
  const baseComponent = (
      <RadioButtonGroupInput
          source={source_name}
          key={index}
          choices={choices}
          className={` ${css_class} `}
          validate={is_required ? [required()] : undefined}

          
      />
  );

  // If dependency information is provided, wrap the base component with FormDataConsumer
  if (dependColumn && dependValue !== undefined) {
      component = (
          <FormDataConsumer key={index}>
              {({ formData, ...rest }) =>
                  formData[dependColumn] === dependValue
                      ? React.cloneElement(baseComponent, { ...rest })
                      : null
              }
          </FormDataConsumer>
      );
  } else {
      // Otherwise, just use the base component directly.
      component = baseComponent;
  }

  return { choices, component };
}


function dateInputFilter(component, source_name, index, css_class, full_width, disabled,field_meta) {



  component = (
    <DateRangeInput
    source={source_name}  
    field_meta={field_meta}
    fullWidth={full_width}
      disabled={disabled}
    />
  );
  return component;
}


function referanceFieldInputFilter(component, source_name, index, css_class, full_width, disabled,field_meta) {




  var extraProps = JSON.parse(field_meta);
        
        
  component = (
    <ReferenceInput
      perPage={extraProps.limit}
      source={source_name}
      reference={extraProps.reference_resource}
      fullWidth
      key={index}
      className={`input-field ${css_class}  `}
      sort={
        extraProps &&
        extraProps.sort_by && {
          field: extraProps.sort_by,
          order: extraProps.sort_order,
        }
      }
    >
      <AutocompleteInput
        fullWidth
        optionText={extraProps.reference_source}
        filterToQuery={(searchText) => ({
          [`${extraProps.reference_source}@_ilike`]: `%${searchText}%`,
        })}
      />
    </ReferenceInput>
  );

return component;

}

function referanceFieldInputSearchFilter(component, source_name, index, css_class, full_width, disabled,field_meta) {




  var extraProps = JSON.parse(field_meta);
        


  component = (
    <FormDataConsumer
      source={source_name}
      fullWidth={full_width}
      className={`input-field ${css_class}  `}
    >
      {({ formData, ...rest }) => (
        <>
          {!extraProps.extra_filter_column &&
            formData[extraProps.filter_column_exist] && (
              <ReferenceInput
                source={source_name}
                reference={extraProps.reference_resource}
                key={index}
                perPage={extraProps.limit}
                fullWidth
                filter={{
                  [extraProps.filter_key]: formData[extraProps.filter_column],
                }}
                {...rest}
              >
                <AutocompleteInput
                  fullWidth
                  optionText={extraProps.reference_source}

                          filterToQuery={(searchText) => ({
          [`${extraProps.reference_source}@_ilike`]: `%${searchText}%`,
        })}
                />
              </ReferenceInput>
            )}
          {extraProps.extra_filter_column &&
            formData[extraProps.filter_column_exist] && (
              <ReferenceInput
                source={source_name}
                reference={extraProps.reference_resource}
                key={index}
                perPage={extraProps.limit}
                filter={{
                  [extraProps.filter_key]: formData[extraProps.filter_column],
                  [extraProps.extra_filter_column]:
                    extraProps.extra_filter_value,
                }}
                {...rest}
              >
                <AutocompleteInput
                  optionText={extraProps.reference_source}
                />
              </ReferenceInput>
            )}
        </>
      )}
    </FormDataConsumer>
  );


return component;

}






const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  align-items: center;
`;

const StyledInnerContainer = styled.div`
  flex: 1;
`;
